"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _auth = _interopRequireDefault(require("./store/auth.epic"));

var _auth2 = _interopRequireDefault(require("./store/auth.reducer"));

var _auth3 = _interopRequireDefault(require("./store/auth.middleware"));

var actions = _interopRequireWildcard(require("./store/auth.actions"));

var helpers = _interopRequireWildcard(require("./store/auth.helpers"));

var selectors = _interopRequireWildcard(require("./store/auth.selectors"));

var AuthModuleConstants = _interopRequireWildcard(require("./constants/auth.constants"));

var _abilities = require("./constants/abilities.constants");

var _tokenUpdate = require("./services/tokenUpdate.service");

var _useAuthTokenInfo = require("./hooks/useAuthTokenInfo");

var _auth8 = _interopRequireWildcard(require("./services/auth.service"));

var _useAuthService = require("./hooks/useAuthService");

var _AuthErrorMessage = _interopRequireDefault(require("./components/AuthErrorMessage"));

var _PrivateRoute = _interopRequireDefault(require("./components/PrivateRoute"));

var _LoginRedirect = _interopRequireDefault(require("./components/LoginRedirect"));

var _AuthLoading = _interopRequireDefault(require("./components/AuthLoading"));

var _HasAbilities = _interopRequireDefault(require("./hoc/HasAbilities"));

var _AuthCallback = _interopRequireDefault(require("./components/AuthCallback"));

var _AccessDenied = _interopRequireDefault(require("./components/AccessDenied"));

var _IntegrationLogin = _interopRequireDefault(require("./components/IntegrationLogin"));

var _IntegrationAuthorization = _interopRequireDefault(require("./components/IntegrationAuthorization"));

var Auth = {
  epics: _auth.default,
  reducer: _auth2.default,
  createAuthMiddleware: _auth3.default,
  selectors,
  actions,
  helpers,
  AuthModuleConstants,
  AuthServiceProvider: _useAuthService.AuthServiceProvider,
  services: {
    createTokenUpdateService: _tokenUpdate.createTokenUpdateService,
    createAuthService: _auth8.default,
    IAuthServiceSettings: _auth8.IAuthServiceSettings,
    IAuthServiceProps: _auth8.IAuthServiceProps
  },
  hooks: {
    useAuthTokenInfo: _useAuthTokenInfo.useAuthTokenInfo,
    useAuthService: _useAuthService.useAuthService
  },
  hoc: {
    HasAbilities: _HasAbilities.default
  },
  ABILITIES: _abilities.ABILITIES,
  AuthLoading: _AuthLoading.default,
  PrivateRoute: _PrivateRoute.default,
  LoginRedirect: _LoginRedirect.default,
  AuthErrorMessage: _AuthErrorMessage.default,
  AuthStrategy: _auth8.AuthStrategy,
  AuthCallback: _AuthCallback.default,
  AccessDenied: _AccessDenied.default,
  IntegrationLogin: _IntegrationLogin.default,
  IntegrationAuthorization: _IntegrationAuthorization.default
};
var _default = Auth;
exports.default = _default;